<template>
  <div id="refund-export-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="refundDialog"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ refundType === 'full' ? 'Full Refund' : 'Partial Refund' }} Export Order</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeDialog"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Order refunded successfully
              </v-alert>
              <v-layout wrap>
                <v-flex sm12>
                  <h5>Order Total amount is ${{ orderPrice.toFixed(2) }}</h5>
                </v-flex>

                <v-flex
                  v-if="alreadyRefunded > 0"
                  sm12
                >
                  <h6>Already Refunded: ${{ alreadyRefunded.toFixed(2) }}</h6>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Money amount*"
                    v-model="refundData.amount"
                    :error-messages="errors.amount"
                    @input="errors.amount = ''"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  sm12
                  v-if="refundType === 'full'"
                >
                  <v-text-field
                    label="Refund Reason*"
                    v-model="refundData.refund_reason"
                    :error-messages="errors.refund_reason"
                    @input="errors.refund_reason = ''"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Refund note"
                    v-model="refundData.refund_note"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Refund</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    refundDialog: {
      type: Boolean,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    refundType: {
      type: String,
      required: true,
      validator: (value) => ['full', 'partial'].includes(value)
    },
    orderPrice: {
      type: Number,
      default: 0
    },
    alreadyRefunded: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loading: false,
      checkAlert: false,
      refundData: {
        amount: '',
        refund_reason: '',
        refund_note: ''
      },
      errors: {
        amount: '',
        refund_reason: ''
      }
    }
  },

  computed: {
    remainingAmount() {
      return this.orderPrice - this.alreadyRefunded
    }
  },

  watch: {
    refundDialog(val) {
      if (val) {
        this.resetForm()
        if (this.refundType === 'full') {
          this.refundData.amount = this.remainingAmount.toFixed(2)
        }
      }
    }
  },

  methods: {
    resetForm() {
      this.refundData = {
        amount: '',
        refund_reason: '',
        refund_note: ''
      }
      this.errors = {
        amount: '',
        refund_reason: ''
      }
      this.checkAlert = false
    },

    submitForm() {
      if (!this.validateForm()) {
        return
      }

      swal({
        title: 'Are you sure?',
        text: 'This will refund $' + parseFloat(this.refundData.amount).toFixed(2) + ' to the customer\'s credit.',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((confirmed) => {
        if (confirmed) {
          this.processRefund()
        }
      })
    },

    validateForm() {
      let isValid = true
      this.errors = {
        amount: '',
        refund_reason: ''
      }

      if (!this.refundData.amount || parseFloat(this.refundData.amount) <= 0) {
        this.errors.amount = 'Please enter a valid refund amount'
        isValid = false
      } else if (parseFloat(this.refundData.amount) > this.remainingAmount) {
        this.errors.amount = `Amount cannot exceed remaining amount: $${this.remainingAmount.toFixed(2)}`
        isValid = false
      } else if (this.refundType === 'partial' && parseFloat(this.refundData.amount) >= this.remainingAmount) {
        this.errors.amount = `Partial refund must be less than remaining amount: $${this.remainingAmount.toFixed(2)}`
        isValid = false
      }

      if (this.refundType === 'full' && !this.refundData.refund_reason.trim()) {
        this.errors.refund_reason = 'Refund reason is required for full refunds'
        isValid = false
      }

      return isValid
    },

    processRefund() {
      this.loading = true
      this.checkAlert = false
      const token = localStorage.getItem('access_token')

      const payload = {
        export_order_id_fk: this.orderId,
        amount: parseFloat(this.refundData.amount),
        refund_type: this.refundType,
        refund_reason: this.refundData.refund_reason || null,
        refund_note: this.refundData.refund_note || null
      }

      axios
        .post('api/export-order-refund', payload, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.checkAlert = true
          this.loading = false
          setTimeout(() => {
            this.closeDialog()
            this.$emit('refund-success')
            swal({
              title: 'Success',
              text: (this.refundType === 'full' ? 'Full' : 'Partial') + ' refund processed successfully',
              icon: 'success',
              timer: 2000,
              buttons: false
            })
          }, 1500)
        })
        .catch((error) => {
          const message = (error.response && error.response.data && error.response.data.message) || 'Failed to process refund'
          swal('Error', message, 'error')
          this.loading = false
        })
    },

    closeDialog() {
      this.resetForm()
      this.$emit('close')
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/exportOrder/refundExportOrder.vue